import { useMemo, useState } from "react";

import { useSearchDatatables } from "App/hooks";

export default function useDatatables({
  rows,
  orderByDefault,
  orderByRow,
  pageSize = 10,
  defaultOrder = "desc",
}) {
  const [order, setOrder] = useState(defaultOrder);
  const [orderBy, setOrderBy] = useState(orderByDefault);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(pageSize);
  const [q, setQ] = useState("");
  const { data, length } = useSearchDatatables(rows, q, orderByRow);
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useMemo(() => {
    const firstPageIndex = (page - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return data.slice(firstPageIndex, lastPageIndex);
  }, [page, data]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    data,
    setQ,
    page: parseInt(page),
    rowsPerPage: parseInt(rowsPerPage),
    order,
    orderBy,
    setPage,
    setRowsPerPage,
    handleRequestSort,
    length,
  };
}
